import { render } from "./ChatIndexPage.vue?vue&type=template&id=0d62669c"
import script from "./ChatIndexPage.vue?vue&type=script&lang=ts"
export * from "./ChatIndexPage.vue?vue&type=script&lang=ts"

import "./ChatIndexPage.vue?vue&type=style&index=0&id=0d62669c&lang=less"
script.render = render

export default script